// @flow
import React from "react";
import {
  TextInput,
  StyleSheet,
  View,
  Text,
  Dimensions,
  TouchableOpacity,
} from "react-native";
import Icon from "react-native-vector-icons/Ionicons";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "react-native-responsive-screen";
import theme from "app/Theme/Theme";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";

const { width, height } = Dimensions.get("window");
const aspectRatio = height / width;
const isPad = () => aspectRatio < 1.6;

type inputType = {
  value: string,
  secureTextEntry?: boolean,
  keyboardType?: string,
  placeholder: string,
  error: string,
  autoFocus?: boolean,
  passwordType?: boolean,
  isPasswordVisible?: boolean,
  onShowPassword: () => mixed,
  onChangeText: () => mixed,
};

const Input = ({
  value,
  testID,
  autoCapitalize,
  onChangeText,
  placeholder,
  secureTextEntry,
  containerPropStyle,
  onShowPassword,
  passwordType,
  isPasswordVisible,
  keyboardType,
  autoFocus,
  error,
}: inputType) => {
  return (
    <View style={styles.mainContainerStyle}>
      <View style={[styles.containerStyle, containerPropStyle]}>
        <TextInput
          testID={testID}
          style={styles.inputStyle}
          keyboardType={keyboardType}
          secureTextEntry={!isPasswordVisible && passwordType}
          // secureTextEntry={!isPasswordVisible}
          placeholder={placeholder}
          autoCapitalize={autoCapitalize}
          // autoCapitalize="none"
          value={value}
          onChangeText={onChangeText}
          autoFocus={autoFocus}
          underlineColorAndroid="transparent"
        />
        {passwordType && (
          <TouchableOpacity
            style={styles.icon}
            onPress={onShowPassword}
            hitSlop={{ top: 20, bottom: 20, left: 20, right: 20 }}
          >
            <Icon
              name={isPasswordVisible ? "ios-eye-off" : "ios-eye"}
              color={theme.colors["neutral.900"]}
              size={20}
            />
          </TouchableOpacity>
        )}
      </View>
      {error ? <Text style={styles.errorStyle}>{error}</Text> : null}
    </View>
  );
};

const styles = StyleSheet.create({
  mainContainerStyle: {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  inputStyle: {
    outlineWidth: 0,
    color: "#4a4a4a",
    paddingRight: 5,
    paddingLeft: 5,
    fontSize: isWebDesktop ? wp("2%") : wp("4.2%"),
    flex: 1,
    width: "100%",
    left: 10,
    justifyContent: "center",
  },
  labelStyle: {
    fontSize: hp("2.2%"),
    paddingLeft: 20,
    flex: 1,
  },
  errorStyle: {
    marginLeft: 15,
    marginRight: 15,
    fontSize: hp("2%"),
    color: "red",
    marginTop: -10,
  },
  containerStyle: {
    flexDirection: "row",
    width: wp("75%"),
    height: hp("6%"),
    minHeight: isPad() ? hp("8%") : 50,
    marginBottom: 12,
    borderRadius: 6,
    borderWidth: 2,
    borderColor: theme.colors["brand.500"],
    alignItems: "center",
    justifyContent: "center",
  },
  icon: {
    marginRight: 10,
    marginLeft: 10,
  },
});
export { Input };
